import { cellStyle } from "../../../components/Table/Table.styles";
import { roundToTwo } from "../../../services/utils/roundToTwo";

// define your filters
export const defaultSliderFilters = [
  { id: 3, title: "Team Members", min: 0, max: 10 },
  { id: 5, title: "Missing Check-ins", min: 0, max: 10 },
  { id: 6, title: "Overtime (weeks)", min: 0, max: 52 },
  { id: 8, title: "Average Hours/Wk", min: 0, max: 120 },
  { id: 9, title: "Win Rate %", min: 0, max: 100 },
  { id: 10, title: "Avg. Ticket $", min: 0, max: 1000 },
  { id: 11, title: "Avg. Comp $", min: 0, max: 50000 },
  { id: 12, title: "Advantage %", min: 0, max: 100 },
  { id: 13, title: "Referrals $", min: 0, max: 999 },
];

// define your columns
export const getColumns = (token: string) => {
  return [
    {
      title: "Team Name",
      field: "name",
      align: "left",
      searchable: true,
      cellStyle: cellStyle,
      render: (team: any) => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: "600" as any,
                lineHeight: "18px",
                color: "#373F41",
              }}
            >
              {team.name}
            </span>
            <span>{team.nickname}</span>
          </div>
        );
      },
    },
    {
      title: "Nickname",
      field: "nickname",
      searchable: true,
      hidden: true,
    },
    {
      title: "Lead Team Member",
      field: "lead.leadName",
      searchable: false,
      cellStyle: cellStyle,
      render: (team: any) => {
        if (!team.lead) return <></>;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={`${process.env.REACT_APP_API_URL}/members/${
                team.lead.leadId || ""
              }/photo?authorization=${token}`}
              style={{
                marginRight: "9.22px",
                height: "32px",
                width: "40px",
                borderRadius: "10px",
                objectFit: "cover",
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                fontWeight: "600" as any,
                lineHeight: "18px",
                color: "#373F41",
              }}
            >
              <div>{team.lead.leadName}</div>
            </div>
          </div>
        );
      },
      customSort: (a: any, b: any) =>
        (a.lead?.leadName || "").localeCompare(b.lead?.leadName || ""),
    },
    {
      title: "Lead Score",
      field: "lead.leadScore",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: null,
      render: (team: any) => {
        return roundToTwo(
          parseFloat(team.lead?.leadScore as unknown as string)
        );
      },
    },
    {
      title: "Team Members",
      field: "lead.leadReports",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.lead.leadReports >= value[0] &&
        rowData.lead.leadReports <= value[1],
      render: (team: any) => {
        return roundToTwo(
          parseFloat(team.lead?.leadReports as unknown as string)
        );
      },
    },
    {
      title: "Score",
      field: "score",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: null,
      render: (team: any) => {
        return roundToTwo(parseFloat(team.score as unknown as string));
      },
    },
    {
      title: "Missing Check-ins",
      field: "checkins",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.checkins >= value[0] && rowData.checkins <= value[1],
    },
    {
      title: "OT",
      field: "ot",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.ot >= value[0] && rowData.ot <= value[1],
      render: (team: any) => {
        return roundToTwo(parseFloat(team.ot as unknown as string));
      },
    },
    {
      title: "PTO",
      field: "pto",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.pto >= value[0] && rowData.pto <= value[1],
      render: (team: any) => {
        return roundToTwo(parseFloat(team.pto as unknown as string));
      },
    },
    {
      title: "Hours",
      field: "hours",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.hours >= value[0] && rowData.hours <= value[1],
      render: (team: any) => {
        return roundToTwo(parseFloat(team.hours as unknown as string));
      },
    },
    {
      title: "Win Rate",
      field: "winRate",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.winRate >= value[0] && rowData.winRate <= value[1],
      render: (team: any) => {
        return roundToTwo(parseFloat(team.winRate as unknown as string)) + "%";
      },
    },
    {
      title: "Avg. Ticket",
      field: "avgTicket",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.avgTicket >= value[0] && rowData.avgTicket <= value[1],
      render: (team: any) => {
        return roundToTwo(parseFloat(team.pto as unknown as string));
      },
    },
    {
      title: "Avg. Comp",
      field: "avgComp",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.avgComp >= value[0] && rowData.avgComp <= value[1],
      render: (team: any) => {
        return roundToTwo(parseFloat(team.avgComp as unknown as string));
      },
    },
    {
      title: "Advantage %",
      field: "mam",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.mam >= value[0] && rowData.mam <= value[1],
      render: (team: any) => {
        return roundToTwo(parseFloat(team.mam as unknown as string));
      },
    },
    {
      title: "Referrals",
      field: "referrals",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.referrals >= value[0] && rowData.referrals <= value[1],
      render: (team: any) => {
        return roundToTwo(parseFloat(team.referrals as unknown as string));
      },
    },
  ];
};
